<!--
 * @Author: DLLCNX dllcnx@foxmail.com
 * @Date: 2023-12-26 09:56:15
 * @LastEditors: DLLCNX dllcnx@foxmail.com
 * @LastEditTime: 2023-12-27 15:23:40
 * @FilePath: /smartEarthDemo/src/demo/earth/pRange.vue
 * @Description: 
-->
<template>
    <div style="height:100%;">
        <div id="csContainer"></div>
    </div>
</template>

<script>
    import util from "../../components/util"

    export default {
        mounted() {
            this.init();
        },
        methods: {
            init() {
                let vw = util.getViewer("csContainer",{
                    infoBox: true,
                    selectionIndicator: true,
                });
                this._loadBeijing(vw);
            },

            _loadBeijing(viewer) {
                //Seed the random number generator for repeatable results.
                Cesium.Math.setRandomNumberSeed(0);

                let promise = Cesium.GeoJsonDataSource.load('/demo/static/data/geojson/bj-renkou.geojson');
                promise.then(function (dataSource) {
                    viewer.dataSources.add(dataSource);
                    let entities = dataSource.entities.values;

                    for (let i = 0; i < entities.length; i++) {
                        let entity = entities[i];
                        entity.name = '区域ID： '+ entity.properties.RECID._value;
                        let color = 0;
                        let value = entity.properties.POPULATION._value;
                        switch( true ) {
                            case value === 0 :
                                color = Cesium.Color.GREEN;
                                break;
                            case value>0&&value<=3000 :
                                color = Cesium.Color.GOLD;
                                break;
                            case value>3000&&value<6000 :
                                color = Cesium.Color.BLUE;
                                break;
                            case value>=6000 :
                                color = Cesium.Color.RED;
                                break;
                        }

                        entity.polygon.material = color;
                        // entity.polygon.outline = true;
                        // entity.polygon.extrudedHeight = entity.properties.Population / 50.0;
                        entity.polygon.extrudedHeight = 0;
                    }
                    viewer.zoomTo(entities);
                }).otherwise(function (error) {
                    window.alert(error);
                });
            }
        }
    }
</script>

<style scoped>
    #csContainer {
        height: 100%;
    }
</style>
